import { post } from '../api_helper';
import * as url from '../url_helper';
import { getApiConfig } from '../auth_helper';

//* auth login
export const login = async (data) => {
  return await post(`${url.LOGIN}/signin`, data, getApiConfig());
};
